<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <div style="font-size: 14px;margin-left: 3px">
        <i class="el-icon-star-on" style="font-size: 120%"></i>
          <a @click="getFlowCollect">常用流程</a>
      </div>
      <FlowTypeTree height="85vh" @nodeClick="nodeClick" />
    </div>
    <div class="d-flex-right">
      <div class="search-wrap">
        <div style="font-size: 18px;">{{type_name}}</div>
        <div>
          <el-input size="mini" placeholder="请输入搜关键字" v-model="where.name" clearable style="width: 200px"></el-input>
          <el-button size="mini" type="primary" @click="search">搜索</el-button>
        </div>
      </div>
      <div class="table-wrap">
        <template v-if="pageData&&pageData.list" v-for="(item,key) in pageData.list">
        <div @click="navTo(item)"  class="table-wrap-item" v-if="item.is_hide == 0">
          <el-card shadow="hover" :body-style="{ padding: '0px' }" class="box-card">
            <div class="el-card-item">
              <el-image
                style="width: 35px; height: 35px"
                src="/static/flow-icon.png"
                fit="fit"></el-image>
              {{ item.name }}
            </div>
          </el-card>
        </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FlowTypeTree from "./components/FlowTypeTree";
import Http from "./common/Http";
export default {
  name: "FlowMasterList",
  components: {FlowTypeTree},
  data(){
    return{
      host_url:"",
      loading: false,
      contract_area_id:'',
      where:{
        name:"",
        type_id:"",
      },
      type_name:"",
      pageData:{
        list:[],
        total:0,
        pageSize:30,
        page:1
      },
    }
  },
  mounted() {
    // this.getList();
    this.getFlowCollect();
  },
  methods:{
    nodeClick(e){
      this.where.type_id=e.id;
      this.type_name=e.name;
      this.pageData.page = 1
      this.getList();
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      const that = this;
      let where=JSON.parse(JSON.stringify(that.where));
      where.is_delete=0;
      Http.get("flow/FlowMaster/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    navTo(item){
      let company = this.$route.query.company
      this.$router.push({path:"/flow/FlowView",query:{sheet_id:item.sheet_id,master_id:item.id,timeValue:Date.now(),company:company}});
    },
    getFlowCollect() {
      const that = this;
      let flowCollect = localStorage.getItem("flow_collect");
      Http.get("flow/FlowMaster/getFlowCollect",{
        flow_collect : flowCollect
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.table-wrap {
  margin-top: 5px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: flex-start;
  justify-content: flex-start;

  .table-wrap-item{
    margin: 15px 0;
    //width: 250px;
    margin-left: 40px;
    cursor: pointer;
    //height: 50px;
    .el-card-item{
      padding: 20px;
    }
  }
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 400px );
  //overflow-x: scroll;
}
.box-card {
  font-size: 14px;
  height: 150px;
  width: 18vw;
  border: 2px solid #cccccc;
  border-radius: 0px
}
.el-card:hover {
  box-shadow: 0 1px 6px rgba(255, 255, 255, 0.932);
  border-color: #24CC9B;
  transition: all 0.2s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowMasterList.vue